import { render, staticRenderFns } from "./datagramDetail.vue?vue&type=template&id=25c4e3e0&scoped=true"
import script from "./datagramDetail.vue?vue&type=script&lang=js"
export * from "./datagramDetail.vue?vue&type=script&lang=js"
import style0 from "./datagramDetail.vue?vue&type=style&index=0&id=25c4e3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c4e3e0",
  null
  
)

export default component.exports